export const objectForEach = (obj, fn) => {
  for (const key in obj) {
    // Only consider the keys that are native to this object (i.e. not from the prototype).
    if (!obj.hasOwnProperty(key)) continue;

    fn(key, obj[key]);
  }
};
